<template>
    <div style="width: 100%">
        <AdminTools />
        <div class="flexContainer full what">
            <section id="sectionPrincipal">
                <section class="brand-list">
                    <section class="searchResultsWrapper">
                        <h1 class="headline uppercase">Profiles</h1>
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb">
                                <a tag="span" @click="modalCreateProfile = true;" class="btnExp iBlock pointer txtCenter active fright">
                                    Add Profile
                                </a>
                            </div>
                        </div>
                        <section>
                            <hr class="full mt10 separator" />
                            <div v-for="profile in profiles" :key="profile.id" class="listDisplay rel full flexContainer fd-c ai-c jc-fs">
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of6">
                                            <span class="listTitle uppercase center">{{ profile.name }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of6">
                                            <client-color-button class="listTitle uppercase center" @click="modalEditProfile = profile.id;">
                                                {{ "Edit" }}
                                            </client-color-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
            </section>
        </div>
        <EditProfile
            v-if="modalEditProfile"
            :profile-id="modalEditProfile"
            @cancel="modalEditProfile = null;"
            @editRight="$router.push({ path: `/admin/profiles/${modalEditProfile}` });"
        />
        <CreateProfile v-if="modalCreateProfile" @cancel="modalCreateProfile = null;" />
    </div>
</template>

<script>
import TryLoad from "@/mixins/TryLoadMixin";
import AdminTools from "../../adminTools/Admin";
import userService from "@/services/user";
import EditProfile from "@/components/admin/profiles/EditProfile";
import CreateProfile from "@/components/admin/profiles/CreateProfile";

export default {
    data: () => ({
        profiles: [],
        loading: false,
        modalEditProfile: null,
        modalCreateProfile: null
    }),
    components: {
        CreateProfile,
        EditProfile,
        AdminTools
    },
    mixins: [TryLoad],
    async created() {
        this.profiles = await this.tryLoad(() => userService.getProfiles());
    },
    methods: {},
    computed: {}
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// Profiles.vue?4f7133ab